export enum OrderInProgressConfirmationActions {
  CANCEL = 'cancel',
  PICK = 'pick',
  NEXT_ORDER = 'next order'
}
